export const SideBarBtnType = {
    DELETE: 1,
    ADD: 2,
    COMFIRM: 3,
    SELECT: 4,
    UN_SELECT: 5,
    EDIT: 6,
}